import { render, staticRenderFns } from "./TheBuildingSpaceList.vue?vue&type=template&id=2eb03519&"
import script from "./TheBuildingSpaceList.vue?vue&type=script&lang=js&"
export * from "./TheBuildingSpaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports